import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=d2d5d02a"
import script from "./FullScreen.vue?vue&type=script&lang=js"
export * from "./FullScreen.vue?vue&type=script&lang=js"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=d2d5d02a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports